import { RELEASE_NOTES } from '../data/releaseNotes';

function fmtDate(iso: string) {
  return new Date(iso).toLocaleDateString(undefined, { dateStyle: 'medium' });
}

export function ReleaseNotes() {
  return (
    <div className="release-notes-page">
      <h2 className="location-section-title">Release notes</h2>
      <p className="drawer-hint">
        What&rsquo;s changed in the app itself. Model availability changes are tracked
        separately, in the What&rsquo;s New panel on the main views.
      </p>
      <div className="release-notes-list">
        {RELEASE_NOTES.map((note, i) => (
          <div key={i} className="release-note-entry">
            <div className="whatsnew-date">{fmtDate(note.date)}</div>
            <div className="release-note-title">
              <span className={`badge ${note.kind === 'fix' ? 'whatsnew-expanded' : 'whatsnew-added'}`}>
                {note.kind === 'fix' ? 'fix' : 'new'}
              </span>
              {' '}{note.title}
            </div>
            <p className="release-note-desc">{note.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
